export default __webpack_public_path__ + "static/media/Flat_DarkBlue.ce42feb6.png";